import { render, staticRenderFns } from "./DashboardEditorDialog.vue?vue&type=template&id=f8a652b8&"
import script from "./DashboardEditorDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEditorDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports